import {
  Zap,
  Play,
  Shield,
  Clock,
  Wallet,
  Globe,
  Zap as FastForward,
  Clock as InstallClock,
} from "lucide-react";
import trustpilot from "../assets/logo/trust-pilot1.svg";


export default function Home() {
  return (
    <>
      <section className="home-section bg-gradient-to-br bg-slate-50 animated-bg">
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto pt-4 sm:pt-5 lg:pt-0 pb-5">
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-center">
            {/* Left content */}
            <div className="lg:col-span-7 space-y-6 lg:space-y-8">
              {/* Trustpilot floating badge */}
              <img
                src={trustpilot}
                alt="trustpilot"
                className="w-52 sm:w-64 h-auto -mb-2"
              />

              {/* Main heading with modern typography */}
              <div className="space-y-4 lg:space-y-6">
                <h1 className="text-3xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] font-black text-gray-900 leading-tight text-balance main-title">
                  Bienvenue sur{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
                    TVDIAMO{" "}
                  </span>
                  <br />
                  La Meilleure IPTV en
                  <br /> France et Belgique
                </h1>
                <div className="text-base sm:text-lg font-bold">
                  <span className="text-xl">
                    <span className="footer-logo flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 64 64"><path fill="#428bc1" d="M1.9 32c0 13.1 8.4 24.2 20 28.3V3.7C10.3 7.8 1.9 18.9 1.9 32"></path><path fill="#ed4c5c" d="M61.9 32c0-13.1-8.3-24.2-20-28.3v56.6c11.7-4.1 20-15.2 20-28.3"></path><path fill="#fff" d="M21.9 60.3c3.1 1.1 6.5 1.7 10 1.7s6.9-.6 10-1.7V3.7C38.8 2.6 35.5 2 31.9 2s-6.9.6-10 1.7z"></path></svg>
                       &
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 64 64"><path fill="#ed4c5c" d="M62 32c0-13.1-8.3-24.2-20-28.3v56.6C53.7 56.2 62 45.1 62 32"></path><path fill="#3e4347" d="M2 32c0 13.1 8.4 24.2 20 28.3V3.7C10.4 7.8 2 18.9 2 32"></path><path fill="#ffe62e" d="M42 3.7C38.9 2.6 35.5 2 32 2s-6.9.6-10 1.7v56.6c3.1 1.1 6.5 1.7 10 1.7s6.9-.6 10-1.7z"></path></svg>
                    </span>
                  </span>
                </div>
                <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-700 text-balance">
                  Divertissement premium pour{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
                    votre appareil
                  </span>
                </h2>
              </div>

              {/* Stats cards */}
              <div className="grid grid-cols-3 gap-2 sm:gap-4">
                <div className="bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center border border-white/20 shadow-lg">
                  <div className="text-lg sm:text-2xl font-black text-[#04003b]">
                    79K+
                  </div>
                  <div className="text-xs text-gray-600 font-medium">
                    Chaînes
                  </div>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center border border-white/20 shadow-lg">
                  <div className="text-lg sm:text-2xl font-black text-[#090979]">
                    249K+
                  </div>
                  <div className="text-xs text-gray-600 font-medium">VOD</div>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center border border-white/20 shadow-lg">
                  <div className="text-lg sm:text-2xl font-black text-[#00d4ff]">
                    4K
                  </div>
                  <div className="text-xs text-gray-600 font-medium">
                    Qualité
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <button className="bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] hover:brightness-110 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-lg hover:shadow-xl transition-all duration-500 flex items-center justify-center gap-2 sm:gap-3 min-h-[48px]">
                  <Zap className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span className="text-sm sm:text-base">
                    Activation Immédiate
                  </span>
                </button>
                <a
                  href="#premium-basico"
                  className="bg-white/90 backdrop-blur-sm hover:bg-white text-gray-900 border border-gray-200/50 px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-lg hover:shadow-xl transition-all min-h-[48px] flex items-center justify-center"
                >
                  <span className="text-sm sm:text-base">
                    Commander - 29€/an
                  </span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 space-y-4 lg:space-y-6">
              <div className="relative">
                {/* Main feature card */}
                <div className="bg-gradient-to-br from-white to-blue-50/50 border-0 shadow-2xl rounded-2xl sm:rounded-3xl overflow-hidden">
                  <div className="p-6 sm:p-8">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#04003b] via-[#090979] to-[#00d4ff] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg">
                      <Play className="w-6 h-6 sm:w-8 sm:h-8 text-white fill-white" />
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                      Streaming Premium
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                      Profitez d'une qualité d'image 4K sur n'importe quel
                      appareil avec une disponibilité de 100% et l'activation
                      gratuite d'IBO Pro Player.
                    </p>
                    <button
                    onClick={() => {
                          const element = document.getElementById("pricing");
                          if (element) {
                              element.scrollIntoView({ behavior: "smooth" });
                          }
                        }}
                    className="w-full bg-[#090979] hover:bg-[#0a0a61] text-white rounded-lg sm:rounded-xl font-semibold shadow-lg py-2.5 sm:py-3 transition-colors text-sm sm:text-base min-h-[44px]">
                      Tous les Forfaits
                    </button>
                  </div>
                </div>

                {/* Floating mini cards */}
                <div className="absolute -right-2 sm:-right-4 -top-2 sm:-top-4 bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xl border border-white/20">
                  <Shield className="w-4 h-4 sm:w-6 sm:h-6 text-[#00d4ff] mb-1 sm:mb-2" />
                  <div className="text-xs font-bold text-gray-900">
                    Remboursement
                  </div>
                  <div className="text-xs text-gray-600">Garantie</div>
                </div>

                <div className="absolute -left-2 sm:-left-4 -bottom-[10%] sm:-bottom-[15%] bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xl border border-white/20">
                  <Clock className="w-4 h-4 sm:w-6 sm:h-6 text-[#090979] mb-1 sm:mb-2" />
                  <div className="text-xs font-bold text-gray-900">0.5s</div>
                  <div className="text-xs text-gray-600">
                    Temps de chargement
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12  sm:mt-16 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-4 mb-8 sm:mb-10">
            {/* Garantie de Remboursement */}
            <div className="group hover:shadow-2xl hover:brightness-110 hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <Wallet className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  Garantie de Remboursement
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  Vous n'êtes pas satisfait de votre abonnement IPTV ? Ne vous
                  inquiétez pas ! Nous offrons une garantie de remboursement de
                  15 jours pour un remboursement complet.
                </p>
              </div>
            </div>

            {/* 79.000+ Chaînes */}
            <div className="group hover:shadow-2xl hover:brightness-110 hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <Globe className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  79.000+ Chaînes du Monde Entier
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  Accédez à 79.000 chaînes de TV et 249.000 films et séries,
                  incluant une large sélection de chaînes européennes.
                </p>
              </div>
            </div>

            {/* Connexion Ultra Rapide */}
            <div className="group hover:shadow-2xl hover:brightness-110 hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <FastForward className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  Connexion Ultra Rapide
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  TVDIAMO utilise un serveur dédié européen de haute qualité,
                  permettant aux chaînes de TV de se charger en 0,5 secondes -
                  sans délais ni interruptions.
                </p>
              </div>
            </div>

            {/* Installation Immédiate */}
            <div className="group hover:shadow-2xl hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <InstallClock className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  Installation Immédiate
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  Installez votre abonnement IPTV directement sur n'importe quel
                  appareil. Nous offrons une installation à distance gratuite et
                  l'activation d'IBO Pro Player, sans frais cachés.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
